<template>
  <section>
    <header>
      <site-title :textDelay="0.5" />
      <text-block :revealTransition="true" :marginLess="true">I’m a UI designer and front-end developer based in Melbourne, Australia.</text-block>
    </header>
    <featured-grid />
    <text-block>I love and am good at creating digital solutions for complicated problems.</text-block>
    <work-list listType="latest" />
    <text-block>
      <div>Please contact me via <u class="clip" data-clipboard-text="uxd.jun@gmail.com">email</u> or <a href="https://www.linkedin.com/in/jsonjun/" target="_blank">LinkedIn</a>.</div>
      <em class="clip-message">uxd.jun@gmail.com has been copied to clipboard.</em>
    </text-block>
    <site-footer />
  </section>
</template>

<script>
import SiteTitle from '@/components/SiteTitle.vue'
import TextBlock from '@/components/TextBlock.vue'
import FeaturedGrid from '@/components/FeaturedGrid.vue'
import WorkList from '@/components/WorkList.vue'
import Footer from '@/components/Footer'

export default {
  name: 'home',
  components: {
    'site-title': SiteTitle,
    'text-block': TextBlock,
    'featured-grid': FeaturedGrid,
    'work-list': WorkList,
    'site-footer': Footer
  },
  mounted () {
  } // mounted
}
</script>

<style lang="scss" scoped>
  section {
    width: 100%;
    max-width: $size-max-width;
    margin: 0 auto;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  header {
    height: calc(100vh - 120px);
    min-height: 600px;
    max-height: 900px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @include device(tablet) {
      height: 80vh;
    }

    @include device(mobile) {
      min-height: 400px;
    }
  }

  .home-text-second, .home-text-third {
    height: 60vh;
    min-height: 600px;
    max-height: 900px;

    @include device(tablet) {
      height: 50vh;
      min-height: 400px;
    }
  }
  
</style>




// WEBPACK FOOTER //
// src/pages/Home.vue